import { Controller } from "@hotwired/stimulus"
import { renderStaticMap } from "../lib/static_map"
import { whenIdle } from "../lib/idle"

// Slides a map snapshot under a walk's route sketch once the card is about to scroll into view.
// Without it (offline, no WebGL) the sketch still shows the route on a plain background.
export default class extends Controller {
  static targets = ["image"]
  static values = { frame: Object }

  connect() {
    this.cancelled = false
    // The sketch already shows the route, so the map behind it waits for the page to finish loading
    if (!("IntersectionObserver" in window)) return whenIdle(() => this.cancelled || this.render())

    this.observer = new IntersectionObserver((entries) => {
      if (entries.some(entry => entry.isIntersecting)) {
        this.observer.disconnect()
        whenIdle(() => this.cancelled || this.render())
      }
    }, { rootMargin: "200px" })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.cancelled = true
    this.observer?.disconnect()
  }

  async render() {
    if (this.imageTarget.src) return this.show()

    try {
      const url = await renderStaticMap(this.frameValue)
      if (this.cancelled) return

      this.imageTarget.src = url
      this.show()
    } catch (error) {
      console.warn("Walk map unavailable:", error)
    }
  }

  show() {
    this.imageTarget.hidden = false
    requestAnimationFrame(() => this.imageTarget.classList.remove("opacity-0"))
  }
}
